<template>
  <div>
    <div>
      <!-- v-loading="loading" -->
       <!-- v-horizontal-scroll="horizontalScroll" 设置fixed会出现两个滚动 所以先去掉吸底滚动条-->
      <el-table
        :class="['my-table', { noborderTable: append }]"
        style="width: 100%"
        :style="loading ? { 'min-height': loadingMinHeight + 'px' } : {}"
        :data="tableData"
        :row-key="rowKey"
        :max-height="maxHeight"
        border
        ref="tableRef"
        v-loading="loading"
        empty-text=" "
        @selection-change="handleSelectionChange"
        @sort-change="changeTableSort"
        :row-class-name="classNameFun"
        v-bind="$attrs"
        v-on="$listeners"
        :show-summary="summary"
        :summary-method="getSummaries"
        :element-loading-text="loadingText"
        element-loading-background="rgba(255, 255, 255, 0.9)"
        >
        <!-- 多选框 -->
        <el-table-column
          v-if="selection"
          type="selection"
          :width="selectableWidth ? selectableWidth : '55'"
          :reserve-selection="true"
          :selectable="selectable">
        </el-table-column>

        <el-table-column
          v-if="isIndex"
          :label="indexLabel"
          :width="indexWidth ? indexWidth : 55"
          type="index"></el-table-column>

        <template v-for="(item, index) in tableInfo">
          <!-- 展开收起 -->
          <el-table-column
            v-if="item.type == 'scalable' && !item.notShow"
            :label="item.label"
            :width="setMinWidth(item.width)"
            :min-width="setMinWidth(item.minWidth)"
            :align="item.align"
            :fixed="item.fixed"
            :sortable="item.sortable"
            :key="'scalable' + showOverflowObj['showOverflow' + index] + index">
            <template slot="header">
              {{ item.label }}
              <jd-button
                style="margin-left: 8px"
                @click="showOverflowClick(index)"
                type="blueText"
                v-if="!item.notIcon">
                {{ showOverflowText(index)
                }}<i
                  :class="
                    showOverflowObj['showOverflow' + index]
                      ? 'el-icon-arrow-up'
                      : 'el-icon-arrow-down'
                  "
                  style="margin: -3px 0"></i>
              </jd-button>
            </template>
            <template slot-scope="scope">
              <slot
                :name="item.slot"
                :row="scope.row"
                :rowIndex="scope.$index"
                :textWrap="item.textWrap"
                :overflow="showOverflowObj['showOverflow' + index]"
                v-if="item.slot"></slot>
              <div v-else>
                <el-tooltip
                  v-if="!showOverflowObj['showOverflow' + index]"
                  effect="dark"
                  :content="scope.row[item.prop]"
                  placement="top">
                  <div :class="isTowShow ? 'isTowShowText' : 'hoveTitle'">
                    {{ scope.row[item.prop] }}
                  </div>
                </el-tooltip>
                <div v-else>{{ scope.row[item.prop] }}</div>
              </div>
            </template>
          </el-table-column>
          <!-- 带问号标识提示的 -->
          <el-table-column
            :label="item.label"
            :width="setMinWidth(item.width)"
            :min-width="setMinWidth(item.minWidth)"
            :align="item.align"
            :sortable="item.sortable"
            :prop="item.prop"
            :key="'tips' + index"
            v-else-if="item.type == 'tips' && !item.notShow">
            <template slot="header">
              <div :class="{ sortableStyle: item.sortable }">
                <div
                  :style="
                    'display: flex; align-items: center;justify-content: ' +
                    item.align +
                    ';'
                  ">
                  {{ item.label }}
                  <el-tooltip
                    effect="dark"
                    :content="item.tipsContent"
                    placement="top-start">
                    <template slot="content" v-if="item.isTipsSlot">
                      <div v-html="item.tipsContent"></div>
                    </template>
                    <img
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/tips.svg"
                      style="
                        width: 14px;
                        height: 14px;
                        cursor: pointer;
                        margin-left: 4px;
                      "
                      alt="" />
                  </el-tooltip>
                </div>
              </div>
            </template>
            <template slot-scope="scope">
              <slot
                :name="item.slot"
                :row="scope.row"
                :rowIndex="scope.$index"
                :textWrap="item.textWrap"
                v-if="item.slot"></slot>
              <template v-else>
                {{ scope.row[item.prop] }}
              </template>
            </template>
          </el-table-column>
          <!-- 操作列统一处理 -->
          <el-table-column
            v-else-if="item.type == 'operate' && !item.notShow"
            :label="item.label"
            :width="item.width"
            :align="item.align"
            :key="'operate' + index"
            fixed="right">
            <template slot-scope="scope">
              <slot
                :name="item.slot"
                :row="scope.row"
                :rowIndex="scope.$index"
                :textWrap="item.textWrap"
                v-if="item.slot"></slot>
            </template>
          </el-table-column>
          <!-- 二级 -->
          <el-table-column
            v-else-if="item.type == 'expand' && !item.notShow"
            :key="'expand' + index"
            :type="item.type">
            <template slot-scope="scope">
              <slot
                :name="item.slot"
                :row="scope.row"
                :rowIndex="scope.$index"
                :textWrap="item.textWrap"
                v-if="item.slot"></slot>
            </template>
          </el-table-column>
          <!-- 插槽以及普通类 -->
          <el-table-column
            v-else-if="!item.notShow"
            :prop="item.prop"
            :label="item.label"
            :width="setMinWidth(item.width)"
            :align="item.align"
            :min-width="setMinWidth(item.minWidth)"
            :fixed="item.fixed"
            :sortable="item.sortable"
            :key="index"
            :show-overflow-tooltip="
              showOverflowTooltip || item.showOverflowTooltip
            "
            :header-align="item.textAlign">
            <template #header="scope" v-if="item.slotHead">
              <slot :name="item.slotHead" :column="scope.column"></slot>
            </template>
            <template slot-scope="scope">
              <slot
                :name="item.slot"
                :row="scope.row"
                :rowIndex="scope.$index"
                :textWrap="item.textWrap"
                v-if="item.slot"></slot>
              <template v-else-if="item.formatter">
                {{ item.formatter(scope.row, item) }}
              </template>
              <template v-else-if="item.enum">
                {{ item.enum[scope.row[item.prop]] || scope.row[item.prop] }}
              </template>
              <!-- 树形结构 -->
              <template v-else-if="item.tree">
                {{ scope.row[item.prop] }}
              </template>
              <!-- 普通类型内容 -->
              <template v-else>
                <div>
                  <!-- 兼容两行 -->
                  <div
                    :class="{
                      textHidden: !item.textWrap && !isTowShow,
                      mr6: item.textAlign == 'right' && item.sortable,
                    }"
                    :style="item.textAlign == 'right' ? 'text-align: right;' : ''"
                    >
                    {{ scope.row[item.prop] }}
                  </div>
                </div>
              </template>
            </template>
          </el-table-column>
        </template>
        <!-- 用于显示多级合计 -->
        <slot v-if="!tableInfo.length" />
        <template slot="empty" v-if="isDefaultEmpty">
          <div v-if="!loading" class="flex" style="margin-bottom: 98px; margin-top: 71px">
            <img
              :src="$globalCdn + '/images/leftOrNoCxt.png'"
              style="width: 186px; height: 114px" />
            <span class="notDataText">暂无数据</span>
          </div>
        </template>
        <template slot="empty" v-else>
          <slot v-if="!loading" name="empty"></slot>
        </template>
        <template slot="append">
          <slot name="append"></slot>
        </template>
      </el-table>
      <!-- 自定义加载遮罩 -->
      <!-- <div v-if="loading" class="ant-table-loading">
        <div class="ant-spin ant-spin-spinning">
          <span class="ant-spin-dot ant-spin-dot-spin">
            <i></i><i></i><i></i><i></i>
          </span>
          <div class="ant-spin-text" v-if="loadingText">{{ loadingText }}</div>
        </div>
      </div> -->
    </div>
    <!-- 分页组件 -->
    <div
      style="margin-top: 16px"
      class="new-pagination-page"
      v-if="tableTotal > maxTotal">
      <el-pagination
        style="text-align: right"
        :current-page="pageInfo.pageNum"
        :page-size="pageInfo.pageSize"
        :page-sizes="pageSizes"
        :background="background"
        :layout="layout"
        :total="tableTotal"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        v-show="!pageInfo.noShow"
        :hide-on-single-page="tableTotal < maxTotal" />
    </div>
  </div>
</template>

<script>
/**
 * 表格参数除porps定义的以外 其余与element一致，
 *
 *
 * 列参数
 * 参数定义与element一致部分：
 * prop
 * label
 * width
 * align
 * min-width : 数据最小宽度：140px(minNum) 长文本最小宽度：182px(minText) 时间最小宽度：160px(minTime)
 * fixed
 * sortable
 * showOverflowTooltip
 * arrow ：展示上下箭头
 * arrowKey : 判断上升下降的字段
 * arrowRule : [a,b,c]对应 上升 下降 不变
 *
 * 单独定义
 * type：
 *    index 序号列
 *    tips 末尾有问号，悬浮后有提示文本
 *    scalable 展开&收起
 *
 * 分页器
 * pageNum: 1,
 * pageSize: 10,
 * total: 0, 总条数 也可不在pageInfo传，直接传total
 * noShow  传true 不展示分页器，不传或传false则展示
 */

export default {
  props: {
    maxTotal: {
      type: Number,
      default: 10,
    },
    pageSizes: {
      type: Array,
      default: () => [10, 30, 50, 100, 1000],
    },
    layout: {
      type: String,
      default: "total, prev, pager, next,sizes, jumper",
    },
    tableInfo: {
      type: Array,
      default: () => [],
    },
    // 表格附加行-去掉border
    append: {
      type: Boolean,
      default: false,
    },
    // 表格数据
    tableData: {
      type: Array,
      default: () => [],
    },
    reserveSelection: {
      type: Boolean,
      default: false,
    },
    // 分页信息
    pageInfo: {
      type: Object,
      default: () => {
        return {
          pageNum: 1,
          pageSize: 10,
          total: 0,
        };
      },
    },
    // 多选列
    selection: {
      type: Boolean,
      default: false,
    },
    rowKey: {
      // 换页也勾选中（数据唯一值）
      type: null,
      default: "",
    },
    // 加载中
    loading: {
      type: Boolean,
      default: false,
    },
    loadingText: {
      type: String,
      default: "加载中...",
    },
    loadingMinHeight: {
      type: [String, Number],
      default: 400,
    },
    // 没有数据时显示提示
    emptyText: {
      type: String,
      default: "暂无数据",
    },
    // table最大高度，默认不传
    maxHeight: {
      type: [String, Number],
      default: 500,
    },
    //  当内容过长被隐藏时显示 tooltip
    showOverflowTooltip: {
      type: Boolean,
      default: false,
    },

    // 仅对 type=selection 的列有效，类型为 Function，Function 的返回值用来决定这一行的 CheckBox 是否可以勾选
    selectable: {
      type: Function,
      default: (row, index) => {
        return (row, index) => {
          return true;
        };
      },
    },
    selectableWidth: {
      type: String,
    },
    horizontalScroll: {
      type: String,
      default: "always",
    },

    //分页器的背景色
    background: {
      type: Boolean,
      default: true,
    },
    //使用默认的空数据提示
    isDefaultEmpty: {
      type: Boolean,
      default: true,
    },
    // 是否两行显示
    isTowShow: {
      type: Boolean,
      default: false,
    },
    // 是否开启合计
    summary: {
      type: Boolean,
      default: false,
    },
    // 合计数据
    summaryObj: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 当前页多少条数据 主要用于配合判断多条合计数据
    // tabDataPageTotal: {
    //   type: Number,
    //   default: 1000,
    // },
    // 是否需要序号列
    isIndex: {
      type: Boolean,
      default: false,
    },
    // 序号列宽度
    indexWidth: {
      type: Number,
      default: 50,
    },
    // 多级合计数组
    summaryArr: {
      type: Array,
      default: () => [],
    },
    // 序号列标题
    indexLabel: {
      type: String,
      default: "序号",
    }
  },
  data() {
    return {
      ids: [],
      tabDataPageTotal: 1000,
      showOverflowObj: {},
    };
  },
  watch: {
    summaryArr(newVal) {
      if (newVal.length) {
        this.tabDataPageTotal = this.tableData.length;
        this.summaryArr.map((item) => {
          this.tableData.push(item);
        });
      }
    },
  },
  created() {
    this.tableInfo.map((item, index) => {
      if (item.type == "scalable") {
        this.showOverflowObj["showOverflow" + index] = false;
      }
    });
  },
  computed: {
    tableTotal() {
      return Number(this.pageInfo.total) || 0;
    },
  },
  methods: {
    doLayout() {
      let that = this;
      return that.$refs.tableRef.doLayout();
    },
    showOverflowText(index) {
      return this.showOverflowObj["showOverflow" + index] ? "收起" : "展开";
    },
    setMinWidth(val) {
      if (val == "minNum") {
        return 140;
      } else if (val == "minText") {
        return 182;
      } else if (val == "minTime") {
        return 160;
      } else {
        return val;
      }
    },
    classNameFun({ rowIndex }) {
      let class1 = !this.isTowShow
        ? "tableRowClassNameOne"
        : "tableRowClassNameTow";
      let class2 = rowIndex <= this.tabDataPageTotal - 1 ? "" : "SummarClass";
      return class1 + " " + class2;
    },
    getSummaries(param) {
      const { columns } = param;
      const sums = [];
      columns.map((item, index) => {
        sums[index] = this.summaryObj[item.property] || "";
      });
      return sums;
    },
    showOverflowClick(index) {
      this.showOverflowObj["showOverflow" + index] =
        !this.showOverflowObj["showOverflow" + index];
      this.$forceUpdate();
    },
    handleClearSelection() {
      this.$refs.tableRef.clearSelection();
    },
    handleSort(prop, order) {
      this.$refs.tableRef.sort(prop, order);
    },
    changeTableSort(val) {
      this.$emit("changeTableSort", val);
    },
    handleSelectionChange(val) {
      this.ids = [...val];
      this.$emit("selection-change", this.ids);
      this.$emit("handleSelectionChange", this.ids);
    },
    //分页
    handlePage(page) {
      this.$emit("handlePage", page);
    },
    handleSizeChange(val) {
      this.handlePage({ pageSize: val, pageNum: 1 });
    },
    handleCurrentChange(val) {
      this.handlePage({ pageSize: this.pageInfo.pageSize, pageNum: val });
    },
    toggleRowSelection(row,flag) {
      let that = this;
      return that.$refs.tableRef.toggleRowSelection(row,flag);
    },
    // 重置排序
    handleClearSort() {
      this.$refs.tableRef.clearSort();
    },
  },
};
</script>

<style lang="scss" scoped>
.my-table,
.my-table th,
.my-table td {
  border-color: #e5e9f2 !important;
}
// .my-table::before,.my-table::after {
//   background-color: transparent !important;
// }
.sortableStyle {
  display: inline-block;
}

// 使用深度选择器处理Element UI组件样式
/deep/ .el-table {
  &.el-table--border {
    .el-table__cell {
      border-color: #e5e9f2 !important;
    }
    .el-table-column--selection {
      .cell {
        border-right: none;
      }
    }

    // 处理表头
    thead tr th.el-table-column--selection {
      border-right: none;
    }

    // 处理表体
    tbody tr td.el-table-column--selection {
      border-right: none;
    }

    // 处理固定列
    .el-table-fixed-left {
      .el-table-column--selection {
        border-right: none;
      }
    }
  }
}

// 表体最后一行加上底边框
/deep/ .el-table__body tr:last-child td {
  border-bottom: none !important;
}

// 所有列的最后一列加上右边框
/deep/ .el-table__body td:last-child,
.el-table__header th:last-child {
  border-right: 1px solid #e5e9f2 !important;
}

// 如果有固定列，可能也需要加 
/deep/ .el-table__fixed-right .el-table__fixed-body-wrapper tr td:last-child,
.el-table__fixed .el-table__fixed-body-wrapper tr td:last-child {
  border-right: 1px solid #e5e9f2;
}

/deep/ .my-table {
  border: 1px solid #e5e9f2;
  // border-bottom: none;
  // border-right: none;
  border-radius: 4px;
  // &::after{
  //   width: 0px;
  // }
  // &::before{
  //   height: 0px;
  // }
  .el-table__body {
    td.el-table__cell {
      // color: #333333;
      color: #4c4c4c;
      font-size: 14px !important;
    }
  }
  .el-table__header {
    height: 44px;
    th.el-table__cell {
      // font-weight: bold;
      font-size: 14px !important;
      color: #333;
      background: #F3F5F7;
      font-weight: 400;
      font-family: PingFang SC, PingFang SC;
      height: 44px;
      &.is-right {
        .cell {
          justify-content: flex-end;
        }
      }
      &.is-left {
        .cell {
          justify-content: flex-start;
        }
      }
      &.is-center {
        .cell {
          justify-content: center;
        }
      }
      .cell {
        font-family: PingFang SC, PingFang SC;
        display: flex;
        align-items: center;
        .caret-wrapper {
          .sort-caret.ascending {
            top: 7px;
          }
          .sort-caret.descending {
            bottom: 5px;
          }
        }
      }
    }
  }
  .tableRowClassNameOne {
    height: 44px;
  //   .el-table__cell:last-child{
  //     border-right: none;
  //   }
  // }
  // .tableRowClassNameOne:last-child{
  //   .el-table__cell{
  //     border-bottom: none;
  //   }
  }
  .tableRowClassNameTow {
    height: 60px;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
  }
  .SummarClass {
    > td {
      height: 44px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #4c4c4c;
      background: #f3f5f7;
    }
  }
  // 列表行
  .textHidden {
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .textTowHidden {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 300px;
  }
  .el-table__footer-wrapper .el-table__footer .el-table__cell {
    font-weight: 600 !important;
  }

  .el-table__footer-wrapper .el-table__footer .el-table__cell:first-child {
    color: #4c4c4c !important;
  }
  .el-table .el-table__cell.gutter {
    background: #fafafa;
  }
}
::v-deep .noborderTable {
  border: 0;
}

::v-deep .el-table .el-table__cell {
  padding: 0px 0 1px 0;
}
.floatRight {
  float: right;
}
.hoveTitle {
  text-align: left;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-box-orient: vertical;
}
.isTowShowText {
}
.flex {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.notDataText {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #8186a5;
}
/deep/.has-gutter {
  > tr > td {
    height: 44px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #333333 !important;
    background: #f3f5f7 !important;
  }
}
/deep/.el-table__body-wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
/deep/.el-table__body-wrapper::-webkit-scrollbar-thumb {
  width: 6px; /*滚动条宽度*/
  height: 6px; /*滚动条高度*/
  background: #dadada;
  border-radius: 0px;
}
/deep/.el-table__body-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 0px;
}

/deep/.el-table__fixed-right-patch {
  background: #F3F5F7;
}
/deep/.el-pagination {
  font-weight: 400 !important;
}
/* Ant Design 风格的加载样式 */
.ant-table-loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}

.ant-spin {
  color: #5673ff;
  text-align: center;
}

.ant-spin-spinning {
  display: inline-block;
  opacity: 1;
}

.ant-spin-dot {
  position: relative;
  display: inline-block;
  width: 26px;
  height: 26px;
  font-size: 20px;
}

.ant-spin-dot-spin {
  transform: rotate(45deg);
  animation: antRotate 1.2s infinite linear;
}

.ant-spin-dot i {
  position: absolute;
  display: block;
  width: 12px;
  height: 12px;
  background-color: #5673ff;
  border-radius: 100%;
  transform: scale(0.75);
  transform-origin: 50% 50%;
  opacity: 0.3;
  animation: antSpinMove 1s infinite linear alternate;
}

.ant-spin-dot i:nth-child(1) {
  top: 0;
  left: 0;
}

.ant-spin-dot i:nth-child(2) {
  top: 0;
  right: 0;
  animation-delay: 0.4s;
}

.ant-spin-dot i:nth-child(3) {
  right: 0;
  bottom: 0;
  animation-delay: 0.8s;
}

.ant-spin-dot i:nth-child(4) {
  bottom: 0;
  left: 0;
  animation-delay: 1.2s;
}

.ant-spin-text {
  margin-top: 10px;
  color: #5673ff;
}

@keyframes antRotate {
  to {
    transform: rotate(405deg);
  }
}

@keyframes antSpinMove {
  to {
    opacity: 1;
  }
}
</style>
